shadow$provide[419] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vPixelSize;

float getDiamondMask(vec2 uv) {
  vec2 a = abs(uv);
  return a.x + a.y;
}
`;

};